export default "__VITE_ASSET__BMeBX5G6__";